// src/components/HeaderIcons.jsx
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import { FaUsersGear } from "react-icons/fa6";
import { BiLogOutCircle } from "react-icons/bi";
import { useAuth } from "../../Context/AuthContext";

import "./HeaderIcons.css"
import { Pointer } from "lucide-react";

const HeaderIcons = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleProfileClick = () => {
    if (user) {
      navigate("/profile");
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="containerTop">
      {/* אייקון פרופיל/התחברות */}
      <FaUserCircle size={28}
        title={user ? `פרופיל - ${user.name}` : "Admin Only"}
        onClick={handleProfileClick}
        cursor={Pointer}
        className="profile"
      />

      {/* רק למנהלים */}
      {user?.isAdmin && (
        <Link to="/admin/users" title="ניהול משתמשים" className="users">
          <FaUsersGear size={28} />
        </Link>
      )}
      {user && (
        <BiLogOutCircle size={28} title="התנתקות מהמערכת" className="exit" onClick={logout}/> 
      )}
    </div>
  );
};

export default HeaderIcons;
